const DEVELOPMENT_ENVIRONMENT = "development";
export const ASOFOM_ORGANIZATION_ID = "696fe6b02268d27aba1d58e6";

export const PRODUCT_SERVICES_ORGANIZATION_IDS = [
  "696fe6b02268d27aba1d58e6", // ASOFOM
  "6500e21c80d167001bf44b63", // Canaco León
];

export const isDevelopmentEnvironment = () =>
  process.env.VUE_APP_ENVIRONMENT === DEVELOPMENT_ENVIRONMENT;

const getId = (value) => {
  if (!value) return null;
  if (typeof value === "object") return value._id || value.id || null;
  return value;
};

const getUserOrganizationIds = (user) => {
  if (!user) return [];

  return [
    getId(user._id),
    getId(user.organization),
    getId(user.headOffice),
  ].filter(Boolean);
};

export const canAccessProductServices = (user) =>
  isDevelopmentEnvironment() ||
  getUserOrganizationIds(user).some((id) =>
    PRODUCT_SERVICES_ORGANIZATION_IDS.includes(id)
  );

export const canAccessVoting = (user) =>
  isDevelopmentEnvironment() ||
  getUserOrganizationIds(user).includes(ASOFOM_ORGANIZATION_ID);

